import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastsManager, ToastOptions } from 'ng2-toastr/ng2-toastr';

/**
 * shared services providers
 */
import {
    HttpClientService,
    CookieManagerService,
    ErrorManagerService,
    TimeService,
    SwalService,
    BasicTimerService,
} from './shared/';
/**
 * main routing
 */
const appRoutes: Routes = [ ];

/**
 * main providers
 */
export const appRoutingProviders: any[] = [
    /**
     * Shared services route providers
     */
    HttpClientService,
    CookieManagerService,
    ErrorManagerService,
    TimeService,
    SwalService,
    BasicTimerService,
    TranslateService,
    ToastsManager, ToastOptions];

export const appRouting: ModuleWithProviders = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/app.routes.ts